import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import './StubButton.css';
const b = block('stub-button');
export function StubButton({ size, icon }) {
    return (_jsx("span", { className: b({ size }), children: _jsx("span", { className: b('icon'), children: _jsx(Icon, { data: icon }) }) }));
}
